import React, { useState } from 'react';
import { useParams, Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { MapPin, Briefcase, List } from "lucide-react";
import { useJob } from "../hooks/useAPI";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { Form, FormField, FormItem, FormLabel, FormControl } from '../components/ui/form';
import { toast } from 'sonner';
import { useForm } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { applyJob} from '../hooks/useAPI';


const JobDetailsPage = () => {
  const { jobId } = useParams();
  const { data: job, loading: jobLoading } = useJob(jobId);
     const [resumeDialogOpen, setResumeDialogOpen] = useState(false);
 // open resume dialog and optionally prefill job id
  const handleResumeSubmission = (jobId) => {
      try {
        form.setValue('jobs_id', job.job_id);
      } catch (err) {
        // setValue may fail if form not initialized yet — ignore
      }
    setResumeDialogOpen(true);
  };

const availabilityOptions = [
  { value: 'immediately', label: 'Immediately' },
  { value: '2-weeks-notice', label: '2 weeks notice' },
  { value: '1-month-notice', label: '1 month notice' },
  { value: 'flexible', label: 'Flexible' }
];
const resumeFields = [
  { name: 'jobs_id', label: 'Job ID', type: 'text', required: true },
  { name: 'name', label: 'Full Name', type: 'text', required: true },
  { name: 'email', label: 'Email', type: 'email', required: true },
  { name: 'phone_number', label: 'Phone Number', type: 'text', required: true },
  { name: 'years_of_experience', label: 'Years of Experience', type: 'number', required: true },
  { name: 'current_role', label: 'Current Role', type: 'text', required: true },
  { name: 'preferred_location', label: 'Preferred Location', type: 'text', required: true },
  { name: 'expected_salary_range', label: 'Expected Salary Range', type: 'text', required: true },
  { name: 'availability', label: 'Availability', type: 'select', required: true },
  { name: 'key_skills_expertise', label: 'Key Skills & Expertise', type: 'text', required: true },
  { name: 'linkedIn_profile', label: 'LinkedIn Profile', type: 'text', required: true },
  { name: 'resume', label: 'Resume', type: 'file', required: true },
  { name: 'career_goals_additional_information', label: 'Career Goals / Additional Information', type: 'textarea', required: true },
];
    const handleResumeFormSubmit = (data) => {
      // Convert file to just name for logging
      const logData = { ...data, resume: data.resume && data.resume[0] ? data.resume[0].name : null };
      // console.log('Resume Submission:', JSON.stringify(logData, null, 2));
      // submit the form
      var res = applyJob(JSON.stringify(logData, null, 2));
      console.log("Resume submission response:", res);
      if (res) {
        toast.success('Your request sent successfully. Will get back soon.');
      }
      setResumeDialogOpen(false);
      form.reset();
    };

      const form = useForm({
        defaultValues: {
          jobs_id: '',
          name: '',
          email: '',
          phone_number: '',
          years_of_experience: '',
          current_role: '',
          preferred_location: '',
          expected_salary_range: '',
          availability: '',
          key_skills_expertise: '',
          linkedIn_profile: '',
          resume: null,
          career_goals_additional_information: '',
        },
        mode: 'onChange'
      });
  if (!job) {
    return (
      <div className="container" style={{ padding: 24 }}>
        <h2 className="heading-large">Job not found</h2>
        <p className="body-large" style={{ marginTop: 8 }}>We couldn't find a job with ID: {jobId}</p>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Button className="btn-primary" style={{ marginTop: 16 }}>Back to Home</Button>
        </Link>
      </div>
    );
  }

  return (
    <>
      <Header />
    <div className="container" style={{ padding: 24,marginTop: 102, marginBottom: 32 }}>
      <Link to="/" style={{ textDecoration: "none" }}>
        <Button variant="outline" className="btn-secondary" style={{ marginBottom: 16 }}>Back</Button>
      </Link>
      {jobLoading ? (
        <div>Loading...</div>
      ) : (
        <Card className="  testimonial-content" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '16px', marginBottom: '16px',boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
          <CardHeader>
            <CardTitle className="heading-large">{job?.title}</CardTitle>
            <CardDescription className="body-large">{job?.company}</CardDescription>
          </CardHeader>
        <CardContent>
           <div className="job-details">
              <div className="job-info">
                <List size={16} className="info-icon" />
                <span className="body-small">{job?.job_id}</span>
              </div>
              <div className="job-info">
                <MapPin size={16} className="info-icon" />
                <span className="body-small">{job?.location}</span>
              </div>
              <div className="job-info">
                <Briefcase size={16} className="info-icon" />
                <span className="body-small">{job?.industry_details.name}</span>
              </div>
              <div className="job-info">
                <span className="body-small salary">{job?.salary}</span>
              </div>
            </div>
              <blockquote
              className="body-standard body-small job-description"
              dangerouslySetInnerHTML={{ __html: job?.description }}/>
                      


          {Array.isArray(job?.skills) && job?.skills.length > 0 && (
            <div className="job-skills" style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
              {job?.skills.map((skill, idx) => (
                <span key={idx} className="skill-badge" style={{ padding: "4px 10px", borderRadius: 12, border: "1px solid var(--border-light)" }}>{skill}</span>
              ))}
            </div>
          )}

          <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
            {/* <a href="#contact" style={{ textDecoration: "none" }}> */}
              <Button className="btn-primary" onClick={handleResumeSubmission} >Apply / Contact</Button>
            {/* </a> */}
            <Link to="/" style={{ textDecoration: "none" }}>
              <Button variant="outline" className="btn-secondary">Back to Jobs</Button>
            </Link>
          </div>
        </CardContent>
      </Card>)}
    </div>
 
    {/* footer set to bottom  */}
    <Footer/>
           {/* Resume Submission Dialog */}
      <Dialog open={resumeDialogOpen} onOpenChange={setResumeDialogOpen}>
        <DialogContent style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '24px',
          maxWidth: '800px',
          width: '90%',
          maxHeight: '90vh',
          overflowY: 'auto',
          zIndex: 10000,
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
        }}>
          <DialogHeader>
            <DialogTitle>Submit Your Resume</DialogTitle>
            <DialogDescription>
              Fill out the form below and our team will get back to you soon.
            </DialogDescription>
          </DialogHeader>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleResumeFormSubmit)} style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '16px',
              marginTop: '10px'
            }}>
              {resumeFields.map((field) => (
                <FormField
                  key={field.name}
                  name={field.name}
                  control={form.control}
                  rules={{
                    required: field.required ? `${field.label} is required` : false,
                    ...(field.type === 'email' && {
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Invalid email address'
                      }
                    }),
                    ...(field.name === 'phone_number' && {
                      pattern: {
                        value: /^[\\+]?[1-9][\d]{0,15}$/,
                        message: 'Invalid phone number'
                      }
                    }),
                    ...(field.name === 'years_of_experience' && {
                      min: {
                        value: 0,
                        message: 'Years of experience must be 0 or greater'
                      },
                      max: {
                        value: 50,
                        message: 'Years of experience cannot exceed 50'
                      }
                    }),
                    ...(field.name === 'linkedIn_profile' && {
                      pattern: {
                        value: "",
                        message: 'Please enter a valid LinkedIn profile URL'
                      }
                    }),
                    ...(field.name === 'resume' && {
                      validate: (value) => {
                        if (!value || value.length === 0) {
                          return 'Resume file is required';
                        }
                        const file = value[0];
                        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
                        if (!allowedTypes.includes(file.type)) {
                          return 'Please upload a PDF, DOC, or DOCX file';
                        }
                        if (file.size > 5 * 1024 * 1024) { // 5MB
                          return 'File size must be less than 5MB';
                        }
                        return true;
                      }
                    })
                  }}
                  render={({ field: rhfField, fieldState }) => (
                    <FormItem style={{ marginBottom: '1px' }}>
                      <FormLabel style={{
                        display: 'block',
                        marginBottom: '1px',
                        fontWeight: '500',
                        fontSize: '14px',
                        color: '#333'
                      }}>
                        {field.label}{field.required && ' *'}
                      </FormLabel>
                      <FormControl>
                        {field.type === 'textarea' ? (
                          <textarea 
                            {...rhfField} 
                            rows={3} 
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: `1px solid ${fieldState.error ? '#dc2626' : '#ddd'}`,
                              borderRadius: '6px',
                              fontSize: '14px',
                              fontFamily: 'inherit',
                              backgroundColor: fieldState.error ? '#fef2f2' : 'white'
                            }}
                          />
                        ) : field.name === 'resume' ? (
                          <input 
                            type="file" 
                            accept=".pdf,.doc,.docx" 
                            onChange={e => rhfField.onChange(e.target.files)}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: `1px solid ${fieldState.error ? '#dc2626' : '#ddd'}`,
                              borderRadius: '6px',
                              fontSize: '14px',
                              backgroundColor: fieldState.error ? '#fef2f2' : 'white'
                            }}
                          />
                        ) : field.name === 'availability' ? (
                          <Select onValueChange={rhfField.onChange} value={rhfField.value}>
                            <SelectTrigger style={{
                              width: '100%',
                              padding: '12px',
                              border: `1px solid ${fieldState.error ? '#dc2626' : '#ddd'}`,
                              borderRadius: '6px',
                              fontSize: '14px',
                              backgroundColor: fieldState.error ? '#fef2f2' : 'white',
                              cursor: 'pointer'
                            }}>
                              <SelectValue placeholder="Select availability" />
                            </SelectTrigger>
                            <SelectContent style={{
                              zIndex: 10001,
                              backgroundColor: 'white',
                              border: '1px solid #ddd',
                              borderRadius: '6px',
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                            }}>
                              {availabilityOptions.map((option) => (
                                <SelectItem 
                                  key={option.value} 
                                  value={option.value}
                                  style={{
                                    padding: '12px 16px',
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                  }}
                                >
                                  {option.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        ) : (
                          <input 
                            type={field.type} 
                            {...rhfField} 
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: `1px solid ${fieldState.error ? '#dc2626' : '#ddd'}`,
                              borderRadius: '6px',
                              fontSize: '14px',
                              fontFamily: 'inherit',
                              backgroundColor: fieldState.error ? '#fef2f2' : 'white'
                            }}
                          />
                        )}
                      </FormControl>
                      {fieldState.error && (
                        <div style={{
                          color: '#dc2626',
                          fontSize: '12px',
                          marginTop: '4px',
                          fontWeight: '500'
                        }}>
                          {fieldState.error.message}
                        </div>
                      )}
                    </FormItem>
                  )}
                />
              ))}
              <div style={{
                gridColumn: '1 / -1',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '12px',
                marginTop: '0px',
                paddingTop: '10px',
                borderTop: '1px solid #eee'
              }}>
                <button 
                  type="button"
                  onClick={() => setResumeDialogOpen(false)} 
                  style={{
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="submit"
                  style={{
                    backgroundColor: '#1B365D',
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </Form>
        </DialogContent>
      </Dialog>
    


    </>

  );
};

export default JobDetailsPage;


